import { IonIcon, IonRouterLink } from '@ionic/react';
import React from 'react';

import { Spacer } from '@/components/common';
import { useInView } from '@/hooks';
import { ROUTES } from '@/utils/routes';

import './Step.css';

interface StepProps {
  step: {
    id: number;
    icon: string;
    title: string | React.ReactNode;
    description: string;
    image: string;
  };
}

const Step: React.FC<StepProps> = ({ step }) => {
  const copy = {
    tryItNow: 'Try it now'
  };

  const [ref, inView] = useInView({
    threshold: 0.12,
    triggerOnce: true
  });

  return (
    <div className={`step ${inView ? 'step--in-view' : ''}`} ref={ref}>
      <div className="step__icon-container">
        <div className="step__icon">
          <IonIcon icon={step.icon} />
        </div>
        {step.id !== 5 && <div className="step__line"></div>}
      </div>
      <div className="step__content">
        <div className="step__image-container">
          <img
            src={step.image}
            alt={`Step ${step.id}`}
            className={`step__image ${step.id === 3 ? 'step__image--center' : ''}`}
          />
        </div>
        <Spacer top={16} bottom={8}>
          <div className="step__header">
            <p className="step__number">{step.id}</p>
            <p className="step__title">
              <span className="step__title-spacer"></span>
              {step.title}
            </p>
          </div>
        </Spacer>
        <p className="step__details">
          {step.description}{' '}
          {step.id === 1 && (
            <IonRouterLink href={ROUTES.DEMO} target="_blank">
              {copy.tryItNow}
            </IonRouterLink>
          )}
        </p>
      </div>
    </div>
  );
};

export default Step;
